import { render, staticRenderFns } from "./toTop.vue?vue&type=template&id=2021f4fa&scoped=true"
import script from "./toTop.vue?vue&type=script&lang=js"
export * from "./toTop.vue?vue&type=script&lang=js"
import style0 from "./toTop.vue?vue&type=style&index=0&id=2021f4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2021f4fa",
  null
  
)

export default component.exports